
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Job Priority",
    "tableTitle": "Job Priority List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/job_priority/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/job_priority`,
        edit: `${baseUrl}/api/mms/job_priority/edit`,
        delete: `${baseUrl}/api/mms/job_priority/remove`
    },
    "tableCol": [
        {
            name: 'Job Priority',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Job Priority',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "jobPriority": "dgdg"
    }]
}